/*
  GLG Spatial State — OpenAI v5 canonical state helper
  UI Layer: D Shared State

  Owns:
  - window.GLGSpatialState

  Does not own:
  - UI layout
  - API execution
  - GFun
  - CSS
*/
(function () {
  'use strict';

  if (window.GLGSpatialState && window.GLGSpatialState.version === '5.0-openai-spatial-state') return;

  var VERSION = '5.0-openai-spatial-state';

  var MARKET_ALIASES = {
    spatial: 'urban-renewal',
    'spatial-os': 'urban-renewal',
    renewal: 'urban-renewal',
    urban_renewal: 'urban-renewal',
    'urban-renewal': 'urban-renewal',
    gis: 'digital-city',
    map: 'digital-city',
    mapping: 'digital-city',
    survey: 'digital-city',
    twin: 'digital-city',
    'digital-twin': 'digital-city',
    '3d': 'digital-city',
    valuation: 'property-assets-investment',
    asset: 'property-assets-investment',
    property: 'property-assets-investment'
  };

  var SCENARIO_ALIASES = {
    'urban-renewal': 'urban-village-renewal',
    'digital-city': 'spatial-intelligence-platform',
    'property-assets-investment': 'review-brief'
  };

  function hasValue(value) {
    return value !== null && value !== undefined && String(value).trim() !== '';
  }

  function clean(value) {
    return String(value || '').trim();
  }

  function token(value) {
    return clean(value).toLowerCase().replace(/_/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-');
  }

  function normalizeMarket(value) {
    var key = token(value);
    if (!key) return '';
    return MARKET_ALIASES[key] || key;
  }

  function normalizeScenario(value, market) {
    var key = token(value);
    if (key && SCENARIO_ALIASES[key]) return SCENARIO_ALIASES[key];
    if (key && !MARKET_ALIASES[key]) return key;
    var normalizedMarket = normalizeMarket(market || value);
    return SCENARIO_ALIASES[normalizedMarket] || key || '';
  }

  function normalize(state) {
    var next = Object.assign({}, state || {});

    if (!next.market && next.market_handle) next.market = next.market_handle;
    if (!next.market && next.context) next.market = next.context;
    if (!next.market && next.intent) next.market = next.intent;

    if (hasValue(next.market)) next.market = normalizeMarket(next.market);
    if (!next.market_handle && next.market) next.market_handle = next.market;

    if (!next.scenario && next.intent) next.scenario = next.intent;
    if (!next.scenario && next.market) next.scenario = normalizeScenario('', next.market);
    if (hasValue(next.scenario)) next.scenario = normalizeScenario(next.scenario, next.market);
    if (!next.intent && next.scenario) next.intent = next.scenario;
    if (hasValue(next.intent)) next.intent = normalizeScenario(next.intent, next.market);

    if (!next.context && next.market) next.context = next.market;
    if (hasValue(next.context)) next.context = normalizeMarket(next.context);

    if (!next.api_family) next.api_family = 'open3dmap';
    if (!next.canonical_endpoint) next.canonical_endpoint = '/api/map/layer';
    if (!next.delivery_method) next.delivery_method = 'instant';
    if (!next.engine_type) next.engine_type = 'map_engine';
    if (!next.result_surface) next.result_surface = 'workspace';
    if (!next.source) next.source = 'glg-spatial-state';
    next.gse_version = VERSION;

    return next;
  }

  function read() {
    var params = new URLSearchParams(window.location.search || '');
    var state = {};
    params.forEach(function (value, key) {
      if (hasValue(value)) state[key] = value;
    });
    return normalize(state);
  }

  function serialize(state) {
    var normalized = normalize(state || {});
    var params = new URLSearchParams();
    Object.keys(normalized).forEach(function (key) {
      if (hasValue(normalized[key])) params.set(key, normalized[key]);
    });
    return params.toString();
  }

  function withState(url, extra) {
    if (!url || url === '#') return url || '#';
    var parsed;

    try {
      parsed = new URL(url, window.location.origin);
    } catch (_) {
      return url;
    }

    var state = normalize(Object.assign({}, read(), extra || {}));
    Object.keys(state).forEach(function (key) {
      if (hasValue(state[key])) parsed.searchParams.set(key, state[key]);
    });

    if (url.indexOf('://') >= 0) return parsed.toString();
    return parsed.pathname + parsed.search + parsed.hash;
  }

  window.GLGSpatialState = {
    version: VERSION,
    normalize: normalize,
    read: read,
    serialize: serialize,
    withState: withState,
    normalizeMarket: normalizeMarket,
    normalizeScenario: normalizeScenario
  };

  try {
    window.dispatchEvent(new CustomEvent('glg:spatial-state-ready', { detail: { version: VERSION } }));
  } catch (_) {}
})();
